import React from 'react';
import collegeConfig from '../../config/collegeConfig';
import './Login.css';
import './PrivacyPolicy.css';

const PrivacyPolicy = ({ onBack }) => {
  return (
    <div className="login-container">
      <div className="login-background">
        <div className="animated-bg-element element-1"></div>
        <div className="animated-bg-element element-2"></div>
        <div className="animated-bg-element element-3"></div>
      </div>

      <div className="pp-card">
        <button className="pp-back-btn" onClick={onBack}>
          ← Back to Login
        </button>

        <div className="pp-header">
          <img
            src={collegeConfig.logo}
            alt={`${collegeConfig.shortName} Logo`}
            className="pp-logo"
          />
          <h1 className="pp-title">Privacy Policy</h1>
          <p className="pp-subtitle">{collegeConfig.appName}</p>
          <p className="pp-institution">{collegeConfig.collegeName}</p>
        </div>

        <p className="pp-updated">Last updated: April 2026</p>

        <div className="pp-section">
          <h2>Overview</h2>
          <p>
            This Privacy Policy describes how the <strong>{collegeConfig.appName}</strong> (the "App"),
            operated by <strong>{collegeConfig.collegeName} ({collegeConfig.shortName})</strong>, handles
            information. We are committed to protecting your privacy.
          </p>
        </div>

        <div className="pp-section">
          <h2>Information We Collect</h2>
          <p>
            To provide the App's features, we collect and store the following information on our secure servers:
          </p>
          <ul>
            <li>Your name and institutional user ID (created by your institution's administrators)</li>
            <li>Logbook entries, case submissions, and assessment records you create within the App</li>
            <li>Certificates and documents (PDFs or images) that you choose to upload</li>
            <li>Push notification tokens to deliver academic reminders to your device</li>
          </ul>
          <p>
            This information is linked to your institutional account and is used solely to operate the App's academic features.
          </p>
        </div>

        <div className="pp-section">
          <h2>Information We Do Not Collect</h2>
          <p>
            We do <strong>not</strong> collect:
          </p>
          <ul>
            <li>Device identifiers or hardware information</li>
            <li>Location data</li>
            <li>Contacts or browsing history</li>
            <li>Browsing history or behaviour analytics</li>
            <li>Payment information</li>
          </ul>
        </div>

        <div className="pp-section">
          <h2>File and Document Uploads</h2>
          <p>
            When you choose to upload a certificate or document (PDF or image), that file is
            transmitted to our secure server and stored as part of your logbook record. We do
            not access any files on your device beyond what you explicitly select and upload.
            Uploaded files are only accessible to you and authorised faculty or administrators
            of your institution.
          </p>
        </div>

        <div className="pp-section">
          <h2>How Login Works</h2>
          <p>
            Your name and institutional email address are already held by{' '}
            <strong>{collegeConfig.collegeName}</strong> as part of your enrolment or employment
            record. Your login credentials for this App are created by the institution's
            administrators based on those existing records.
          </p>
          <p>
            Your login simply verifies your identity against the institution's existing database.
          </p>
        </div>

        <div className="pp-section">
          <h2>Data Storage</h2>
          <p>
            All academic data (case submissions, logbook entries, assessment records, uploaded files) is
            stored securely on servers managed by{' '}
            <strong>{collegeConfig.collegeName}</strong>. Access is restricted to
            authorised personnel only (students, teachers, and administrators of the institution).
          </p>
        </div>

        <div className="pp-section">
          <h2>Third-Party Sharing</h2>
          <p>
            We do <strong>not</strong> sell, trade, rent, or share any data with third parties.
            Your information is used solely for academic record-keeping within the institution.
          </p>
        </div>

        <div className="pp-section">
          <h2>Push Notifications</h2>
          <p>
            The App may send push notifications to remind you about pending logbook submissions
            or assessment deadlines. You can disable notifications at any time through your
            device settings or the Notification Settings within the App.
            Notification tokens are stored only on the institution's servers and are not
            shared with any third party.
          </p>
        </div>

        <div className="pp-section">
          <h2>Children's Privacy</h2>
          <p>
            This App is intended for postgraduate medical students and academic staff. It is
            not directed at anyone under the age of 18.
          </p>
        </div>

        <div className="pp-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be
            reflected with an updated date at the top of this page.
          </p>
        </div>

        <div className="pp-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="pp-contact">
            <strong>{collegeConfig.collegeName}</strong><br />
            Email:{' '}
            <a href={`mailto:${collegeConfig.supportEmail}`} className="pp-email">
              {collegeConfig.supportEmail}
            </a>
          </p>
        </div>

        <button className="pp-back-btn pp-back-btn-bottom" onClick={onBack}>
          ← Back to Login
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
